import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { FinDeNavListFilesRequest, ClientInvoice, ImportUploadUrlResponse } from '../Models/Invoice';
import { environment } from '../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class UploadModalService{
   // private apiUrl = 'https://localhost:7276/api'; // 
   private apiUrl = environment.apiUrl;
    constructor(private http:HttpClient){
        
    }


    public generateZip(fileName: string, clientInvoices: ClientInvoice[], notes: string, id: string = '', importS3Path: string | null = null) {

        const payload: FinDeNavListFilesRequest = {
          id: id,
          receivedTs: '',
          fileName: fileName,
          clientInvoices: clientInvoices,
          notes: notes,
          status: '',
          total: '',
          importS3Path: importS3Path

        };
        return this.http.post(`${this.apiUrl}/save-client`, payload);
      }

    /** Gets a new record id and a presigned S3 PUT url for the incoming excel. */
    public getImportUploadUrl(fileName: string): Observable<ImportUploadUrlResponse> {
        const params = new HttpParams().set('fileName', fileName);
        return this.http.get<ImportUploadUrlResponse>(`${this.apiUrl}/import-upload-url`, { params });
      }

    /** Uploads the file straight to S3 using the presigned url. The content type must match the signed one. */
    public uploadImportFile(presignedUrl: string, file: File, contentType: string): Observable<unknown> {
        return this.http.put(presignedUrl, file, { headers: new HttpHeaders({ 'Content-Type': contentType }) });
      }

    /**
     * Stores the incoming excel in S3 and returns the record id and key to save with it.
     * Any failure resolves to null so the import itself still goes ahead.
     */
    public storeImportFile(file: File): Observable<{ id: string; importS3Path: string } | null> {
        return this.getImportUploadUrl(file.name).pipe(
          switchMap(res => this.uploadImportFile(res.url, file, res.contentType).pipe(
            map(() => ({ id: res.id, importS3Path: res.importS3Path }))
          )),
          catchError(error => {
            console.error('Storing the import file failed, continuing without it', error);
            return of(null);
          })
        );
      }


   


}